import React, { useState } from 'react';
import Listing from '../listing';
import NotificationBar from '../favorites-listing/NotificationBar';
import FavoriteButton from '../listing/FavoriteButton';

function CourseListing(props) {
  const {
    favoriteBtn,
    favoritedBtn,
    barAddedHeading,
    barAddedCopy,
    barRemovedHeading,
    barRemovedCopy,
    barViewFavoritesBtn,
    barViewFavoritesUrl,
    barDismissBtn
  } = JSON.parse(props.labels);

  const [displayNotification, setDisplayNotification] = useState(0);

  const handleShowNotification = add => {
    if (add) {
      if (displayNotification !== 1) {
        setDisplayNotification(1);
      }
    } else {
      if (displayNotification !== 2) {
        setDisplayNotification(2);
      }
    }
  };

  const handleNotificationDismiss = () => {
    setDisplayNotification(0);
  };

  const handleViewFavorites = () => {
    window.location.href = barViewFavoritesUrl;
  };

  const renderNotification = () => {
    const notificationProps = {
      dismiss: true,
      timer: props.timeout,
      onDismiss: handleNotificationDismiss,
      id: '',
      heading: '',
      subdata: '',
      copy: '',
      buttons: [
        {
          label: barViewFavoritesBtn,
          action: handleViewFavorites
        },
        {
          label: barDismissBtn,
          action: handleNotificationDismiss
        }
      ]
    };

    switch (displayNotification) {
    case 1:
      notificationProps.heading = barAddedHeading;
      notificationProps.copy = barAddedCopy;
      break;
    case 2:
      notificationProps.heading = barRemovedHeading;
      notificationProps.copy = barRemovedCopy;
      break;
    default:
      return;
    }

    return <NotificationBar {...notificationProps} />;
  };

  const renderListing = (items, favoriteId, handleFavoriteId) =>
    items.length > 0 && (
      <ul className="course-listing__items">
        {items.map(item => (
          <li className="course-listing-item" key={item.Id}>
            <div className="course-listing-item__link content-card">
              <div className="course-listing-item__content">
                <div className="favorite-card__top-bar">
                  <div className="course-listing-item__icon">
                    {!!item.Icon && (
                      <>
                        <img
                          src={item.Icon}
                          alt={item.Heading}
                          className="content-card__icon favorite-card__top-icon "
                        />
                        <div className="icon-divider"></div>
                      </>
                    )}
                  </div>
                  {item.CanFavorite && (
                    <FavoriteButton
                      favorited={item.Favorited}
                      id={item.Id}
                      favoriteId={favoriteId}
                      handleFavoriteId={handleFavoriteId}
                      labelFavorite={favoriteBtn}
                      labelFavorited={favoritedBtn}
                      loggedIn={props.loggedIn}
                      postEndpoint={props.postEndpoint}
                      onHandleNotification={handleShowNotification}
                    />
                  )}
                </div>
                {!!item.Heading && (
                  <a
                    className="course-listing-item__heading-link"
                    href={item.Url}
                  >
                    <h2 className="course-listing-item__heading">
                      {item.Heading}
                    </h2>
                  </a>
                )}
                {(!!item.Topic || !!item.Institution) && (
                  <p className="course-listing-item__topic-institution-wrapper">
                    {!!item.Topic && (
                      <span className="course-listing-item__topic">
                        {item.Topic}
                      </span>
                    )}
                    {!!item.Institution && (
                      <span className="course-listing-item__institution">
                        {item.Institution}
                      </span>
                    )}
                  </p>
                )}
              </div>
              <span className="content-card__faux-button">
                <svg role="presentation" viewBox="0 0 13 13">
                  <use xlinkHref="#arrow-right" />
                </svg>
              </span>
            </div>
          </li>
        ))}
      </ul>
    );

  return (
    <>
      <Listing {...props} renderItems={renderListing} />
      {displayNotification > 0 && renderNotification()}
    </>
  );
}

export default CourseListing;
